import React from "react";
import { ResponsiveModal } from "@UI/Components/ResponsiveModal/ResponsiveModal";
import { VStack } from "@UI/Components/Stack/Stack";
import { Heading } from "@UI/Components/Heading/Heading";
import { ServiceRequestStatusStepIndicator } from "./ServiceRequestStatusStepIndicator";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import messages from "../messages";
export const ServiceRequestStatusModal = (props) => {
  const { isOpen, onClose } = props;

  return (
    <ResponsiveModal isOpen={isOpen} onClose={onClose}>
      <VStack alignItems="start" spacing="28px">
        <Heading as="h4" fontSize={{ base: "1.5rem", lg: "1.725rem" }}>
          <FormattedMessage
            {...messages["serviceRequest.statusStep.whatAreTheNextSteps"]}
          />
        </Heading>
        <ServiceRequestStatusStepIndicator />
      </VStack>
    </ResponsiveModal>
  );
};
